import type { Sesion } from '@/shared/api/tipos';

const CLAVE_ACCESO = 'civitas.acceso';
const CLAVE_REFRESCO = 'civitas.refresco';
const CLAVE_USUARIO = 'civitas.usuario';

export interface SesionGuardada {
  tokenDeAcceso: string;
  tokenDeRefresco: string;
  usuario: Sesion['usuario'];
}

export function guardar(sesion: Sesion): void {
  sessionStorage.setItem(CLAVE_ACCESO, sesion.tokenDeAcceso);
  sessionStorage.setItem(CLAVE_REFRESCO, sesion.tokenDeRefresco);
  sessionStorage.setItem(CLAVE_USUARIO, JSON.stringify(sesion.usuario));
}

export function leer(): SesionGuardada | null {
  const tokenDeAcceso = sessionStorage.getItem(CLAVE_ACCESO);
  const tokenDeRefresco = sessionStorage.getItem(CLAVE_REFRESCO);
  const usuario = sessionStorage.getItem(CLAVE_USUARIO);

  if (!tokenDeAcceso || !tokenDeRefresco || !usuario) {
    return null;
  }

  try {
    return { tokenDeAcceso, tokenDeRefresco, usuario: JSON.parse(usuario) as Sesion['usuario'] };
  } catch {

    borrar();
    return null;
  }
}

export function tokenDeAcceso(): string | null {
  return sessionStorage.getItem(CLAVE_ACCESO);
}

export function tokenDeRefresco(): string | null {
  return sessionStorage.getItem(CLAVE_REFRESCO);
}

export function borrar(): void {
  sessionStorage.removeItem(CLAVE_ACCESO);
  sessionStorage.removeItem(CLAVE_REFRESCO);
  sessionStorage.removeItem(CLAVE_USUARIO);
}
